<template>
  <div class="search-form px-2">
    <div class="col-sm-12 search-form-title">
      <font-awesome-icon icon="search" />
      {{ $t('common.search') }}
    </div>
    <form
      @submit.prevent="onSubmit"
      @reset="onReset"
    >
      <contract-filter
        ref="filter"
        :user="user"
        :show-only-my-contracts-option="true"
        @contract-set="setContract"
        @company-set="companySet"
      />
        <div class="row">
            <div class="col-sm-4">
                <span class="span-title">{{ $t('road_sign.sign_type') }}</span>
                <select
                    v-model="type"
                    class="form-select form-select-sm"
                >
                    <option :value="null">
                        {{ $t('road_sign.select_sign_type') }}
                    </option>
                    <option
                        v-for="item in getRoadSignTypes()"
                        :key="item.value"
                        :value="item.value"
                    >
                        {{ item.name }}
                    </option>
                </select>
            </div>
            <div class="col-sm-4">
                <span class="span-title">{{ $t('road_sign.road_sign') }}</span>
                <multiselect
                    v-model="sign"
                    :placeholder="$t('road_sign.select_sign')"
                    :deselect-label="$t('common.remove_selection')"
                    :select-label="$t('common.select')"
                    :close-on-select="true"
                    :multiple="false"
                    label="name"
                    track-by="name"
                    :searchable="true"
                    :internal-search="true"
                    :selected-label="$t('common.selected')"
                    :options="signs"
                >
                    <template
                        #singleLabel="props"
                    >
                        <div class="row nopads">
                            <div
                                class="col nopads"
                            >
                                <img
                                    class="option__image"
                                    :src="getRoadSignImage(props.option.icon)"
                                    height="25px"
                                    alt=""
                                >
                            </div>
                            <div style="padding-top: 2px;">
                  <span
                      class="option__title"
                      style="font-weight: 400"
                  >{{ props.option.name }}</span>
                            </div>
                        </div>
                    </template>
                    <template
                        #option="props"
                    >
                        <div class="row nopads">
                            <div
                                class="col nopads"
                            >
                                <img
                                    class="option__image"
                                    :src="getRoadSignImage(props.option.icon)"
                                    height="35px"
                                    alt=""
                                >
                            </div>
                            <div class="col pt-2">
                                <span class="option__title pt-2">{{ props.option.name }}</span>
                            </div>
                        </div>
                    </template>

                    <template #noResult>
                        <span>{{ $t('common.not_found') }}</span>
                    </template>
                    <template #noOptions>
                        <span>{{ $t('common.no_results') }}</span>
                    </template>
                </multiselect>
            </div>
            <div class="col-sm-4">
                <span class="span-title">{{ $t('road_sign.condition') }}</span>
                <multiselect
                    v-model="condition"
                    :placeholder="$t('road_sign.select_sign')"
                    :deselect-label="$t('common.remove_selection')"
                    :select-label="$t('common.select')"
                    :close-on-select="true"
                    :multiple="true"
                    label="name"
                    track-by="value"
                    :searchable="true"
                    :internal-search="true"
                    :selected-label="$t('common.selected')"
                    :options="getConditions()"
                >
                    <template
                        #singleLabel="props"
                    >
                        <div class="row nopads">
                            <div class="col" style="padding-top: 2px;">
                  <span
                      class="option__title"
                      style="font-weight: 400"
                  >{{ props.option.name }}</span>
                            </div>
                        </div>
                    </template>
                    <template
                        #option="props"
                    >
                        <div class="row nopads">
                            <div class="col pt-2">
                                <span class="option__title pt-2">{{ props.option.name }}</span>
                            </div>
                        </div>
                    </template>

                    <template #noResult>
                        <span>{{ $t('common.not_found') }}</span>
                    </template>
                    <template #noOptions>
                        <span>{{ $t('common.no_results') }}</span>
                    </template>
                </multiselect>
            </div>
        </div>

        <div class="row">
        <div class="col-sm-6">
          <span class="span-title">{{ $t('orders.create_time') }} - {{
            $t('trip_list.road_sec_from')
          }}</span>
          <input
            id="start"
            v-model="fromDate"
            class="form-control form-control-sm"
            type="date"
          >
        </div>
        <div class="col-sm-6">
          <span class="span-title">{{ $t('orders.create_time') }} - {{
            $t('trip_list.road_sec_to')
          }}</span>
          <input
            id="end"
            v-model="toDate"
            class="form-control form-control-sm"
            type="date"
          >
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <span class="span-title">{{ $t('common.in_use') }} - {{ $t('work_permission.created')}}</span>
            <date-time-picker
                v-model:date="inUseDate"
                format="dd.MM.yyyy HH:mm"
                :enableTimePicker="true"
                :placeholder="$t('observations_videos.search_input_format')"
            />
          </div>
          <div class="col-sm-6">
              <span class="span-title">{{ $t('observation_list.status') }}</span>
              <select
                  v-model="status"
                  class="form-select form-select-sm title"
              >
                  <option
                      v-for="option in statusGroups"
                      :key="option.value"
                      :value="option.value"
                  >
                      {{ option.text }}
                  </option>
              </select>
          </div>
      </div>
      <div class="col-sm-12 button-container">
        <button
          type="submit"
          class="form-button btn btn-sm btn-primary"
        >
          {{ $t('ins_report.search') }}
        </button>
        <button
          type="reset"
          class="form-button btn btn-sm btn-danger"
        >
          {{ $t('ins_report.clear') }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import ContractFilter from '../contract/ContractFilter'
import {timeUtils} from '../mixins/TimeUtils'
import {roadSignHelper, roadSignTypes} from "@/components/mixins/RoadSignMixin";
import DateTimePicker from "@/components/common/DateTimePicker";

const imageModules = import.meta.glob('@/assets/roadsign/**/*.{svg,png,jpg}', {eager: true});
export default {
    name: 'RoadSignSearch',
    components: {DateTimePicker, ContractFilter},
    mixins: [roadSignHelper, timeUtils],
    props: {
        user: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            contract: null,
            company: null,
            fromDate: null,
            toDate: null,
            inUseDate: null,
            type: null,
            sign: null,
            signs: [],
            condition: [],
            status: null,
            statusGroups: [
                {value: null, text: this.$t('observations.search_all')},
                {value: 1, text: this.$t('observations.open')},
                {value: 2, text: this.$t('observations.closed')}
            ]
        }
    },
    watch: {
        type: function (value) {
            if (value === null) {
                this.sign = null
                this.signs = []
            } else {
                this.signs = this.getSigns(this.type)
            }
        }
    },
    methods: {
        getRoadSignImage(iconName) {
            try {
                const imagePath = `/src/assets/roadsign/${iconName}`;
                const imageModule = imageModules[imagePath];

                if (imageModule) {
                    return imageModule.default || imageModule;
                } else {
                    return ""; // Fallback for missing images
                }
            } catch (error) {
                console.warn(`Road sign image not found: ${iconName}`, error);
                return "";
            }
        },
        setContract: function (contract) {
            this.contract = contract
        },
        companySet: function (company) {
            this.company = company
        },
        onSubmit: function () {
            let params = {}
            if (this.contract) {
                params.contract = this.contract
            }
            if (this.fromDate !== null && this.fromDate.trim()) {
                params.created_from = new Date(this.fromDate).getTime()
            }
            if (this.toDate !== null && this.toDate.trim()) {
                params.created_to = new Date(this.toDate).getTime()
            }
            if (this.inUseDate !== null && this.inUseDate.trim()) {
                params.in_use_time = this.inUseDate
            }
            if (this.type) {
                params.type = this.getTypeParam()
            }
            if (this.sign) {
                params.sign = this.sign.value
            }
            if (this.condition && this.condition.length > 0) {
                let conditionIds = []
                this.condition.forEach(cond => {
                    conditionIds.push(cond.value)
                })
                params.condition = conditionIds
            }
            if (this.company) {
                params.company = this.company
            }
            if (this.status) {
                params.status = this.status
            }
            this.$emit('search', params)
        },
        getTypeParam: function () {
            switch (this.type) {
                case roadSignTypes.WARNINGS:
                    return 'A'
                case roadSignTypes.PRIORITIES:
                    return 'B'
                case roadSignTypes.RESTRICTIONS:
                    return 'C'
                case roadSignTypes.COMMANDS:
                    return 'D'
                case roadSignTypes.RULES:
                    return 'E'
                case roadSignTypes.GUIDES:
                    return 'F'
                case roadSignTypes.SERVICES:
                    return 'G'
                case roadSignTypes.ADDITIONAL_PLATES:
                    return 'H'
                case roadSignTypes.OTHERS:
                    return 'I'
                default:
                    return this.type
            }
        },
        onReset: function () {
            this.contract = null
            this.fromDate = null
            this.toDate = null
            this.type = null
            this.condition = []
            this.sign = null
            this.signs = []
            this.company = null
            this.$refs.filter.resetData()
        }
    }
}
</script>
